"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: " 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.44,14.41,18,8.82a4.53,4.53,0,0,0,5.61-6.06.52.52,0,0,0-.36-.3.51.51,0,0,0-.45.14l-2,1.9H19.54V3.19l1.87-2a.53.53,0,0,0,.13-.45.54.54,0,0,0-.3-.36A4.53,4.53,0,0,0,15.18,6L9.59,11.56h0L6,15.19a4.49,4.49,0,0,0-5.61,6,.47.47,0,0,0,.35.29.5.5,0,0,0,.45-.11l2-1.76H4.44V20.9L2.65,22.84a.52.52,0,0,0-.12.45.47.47,0,0,0,.29.35,4.49,4.49,0,0,0,4.94-1A4.59,4.59,0,0,0,8.83,18l3.61-3.62",
    fill: "#014965"
  }));
};

exports["default"] = _default;